// extracted by css-extract-rspack-plugin
export default {"container":"EditableDisabledCell_container__vbOWi","inside-row":"EditableDisabledCell_inside-row__ufZ1u","lineHeight":"EditableDisabledCell_lineHeight__Qbe3j"};